import React from 'react';

const SkeletonGallery = ({ count = 12 }) => {
  return (
    <>
      <div className="gallery">
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className="gallery-item"
            style={{
              position: 'relative',
              opacity: 1, // Override default opacity: 0 from gallery-item
              animation: `skeletonPulse 1.5s ease-in-out infinite`, // Override itemFadeIn animation
              animationDelay: `${index * 0.1}s`,
              cursor: 'default', // No pointer cursor for skeleton
            }}
          >
            <div
              className="image-wrapper"
              style={{
                position: 'relative',
                overflow: 'hidden',
                background: 'rgba(82, 85, 30, 0.15)', // Subtle background matching color scheme
                border: '1px solid rgba(49, 35, 16, 0.15)',
                borderRadius: '2px',
                aspectRatio: '1', // Square aspect ratio like images
                width: '100%',
              }}
            >
              {/* Shimmer effect */}
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: '-100%',
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(90deg, transparent, rgba(198, 162, 91, 0.2), transparent)',
                  animation: 'skeletonShimmer 2s infinite',
                }}
              />
            </div>
          </div>
        ))}
      </div>
      <style>{`
        @keyframes skeletonPulse {
          0%, 100% {
            opacity: 0.6;
          }
          50% {
            opacity: 1;
          }
        }
        @keyframes skeletonShimmer {
          0% {
            left: -100%;
          }
          100% {
            left: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default SkeletonGallery;

